module.exports = __webpack_public_path__ + "img/confetti_3c.33bbc2c2.svg";